"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlurImage = exports.CropImage = exports.NormalizeBaseUrl = exports.CacheKiller = exports.UpdateQueryStringParameter = void 0;
var pattern = /^((http|https|ftp):\/\/)/;
var dataPattern = /^data:((?:\w+\/(?:(?!;).)+)?)((?:;[\w\W]*?[^;])*),(.+)$/;
var baseUrl = 'https://promo.com';
var CDN = 'https://ak01-promo-cdn.slidely.com'; // const CDN = 'http://d1isi6q44tmvpq.cloudfront.net'

var UpdateQueryStringParameter = function UpdateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])".concat(key, "=.*?(&|#|$)"), 'i');

  if (uri.match(re)) {
    return uri.replace(re, "$1".concat(key, "=").concat(value, "$2"));
  }

  var hash = '';

  if (value.indexOf('#') !== -1) {
    hash = uri.replace(/.*#/, '#');
    uri = uri.replace(/#.*/, '');
  }

  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  return "".concat(uri + separator + key, "=").concat(value).concat(hash);
};

exports.UpdateQueryStringParameter = UpdateQueryStringParameter;

var CacheKiller = function CacheKiller(uri) {
  return UpdateQueryStringParameter(uri, 'ck', '140519');
};

exports.CacheKiller = CacheKiller;

var NormalizeBaseUrl = function NormalizeBaseUrl(value) {
  var retVal = value; // if value is base64 retun value as is

  if (dataPattern.test(value)) {
    return retVal;
  }

  if (!pattern.test(value)) {
    // default cdn (production)
    // if (cdn === undefined) {
    //     cdn = CDN
    // }
    retVal = baseUrl + value;
  }

  return CacheKiller(retVal);
};

exports.NormalizeBaseUrl = NormalizeBaseUrl;

var getImageUrl = function getImageUrl(photoUrl, crop, targetW, targetH, cdn, filter) {
  var x = crop.x,
      y = crop.y,
      w = crop.w,
      h = crop.h;
  var filterType = filter ? filter.type : undefined; // eslint-disable-next-line max-len

  var baseColorUrl = "".concat(cdn, "/promoVideos/image-filter/color?url=").concat(encodeURIComponent(photoUrl), "&crop=xywh(").concat(x, ",").concat(y, ",").concat(w, ",").concat(h, ")&targetSize=wh(").concat(targetW, ",").concat(targetH, ")");

  switch (filterType) {
    case 'none':
      return baseColorUrl;

    case 'color':
      // eslint-disable-next-line no-case-declarations
      var _filter$color = filter.color,
          r = _filter$color.r,
          g = _filter$color.g,
          b = _filter$color.b,
          a = _filter$color.a;
      return "".concat(baseColorUrl, "&color=rgba(").concat(r, ",").concat(g, ",").concat(b, ",").concat(a, ")");

    default:
      // eslint-disable-next-line max-len
      return "".concat(cdn, "/promoVideos/photo/cropped-with-transparency/?url=").concat(encodeURIComponent(photoUrl), "&origin_x=").concat(x, "&origin_y=").concat(y, "&origin_w=").concat(w, "&origin_h=").concat(h, "&target_w=").concat(targetW, "&target_h=").concat(targetH);
  }
};

var CropImage = function CropImage(photoUrl, crop, targetW, targetH, cdn, filter) {
  // default value
  if (targetW === undefined || !Number.isInteger(targetW)) {
    targetW = 1280;
  }

  if (targetH === undefined || !Number.isInteger(targetH)) {
    targetH = 720;
  } // default cdn (production)


  if (cdn === undefined) {
    cdn = CDN;
  }

  var url = getImageUrl(photoUrl, crop, targetW, targetH, cdn, filter);
  return url;
}; // blur image for animation include the default value


exports.CropImage = CropImage;

var BlurImage = function BlurImage(photoUrl, width, height, cdn) {
  // default value
  if (width === undefined || !Number.isInteger(width)) {
    width = 640;
  }

  if (height === undefined || !Number.isInteger(height)) {
    height = 360;
  } // default cdn (production)


  if (cdn === undefined) {
    cdn = CDN;
  } // eslint-disable-next-line max-len


  var url = "".concat(cdn, "/promoVideos/background/blur-image/?url=").concat(encodeURIComponent(photoUrl), "&width=").concat(width, "&height=").concat(height, "&fit=fill&blur_radius=40&blur_sigma=10");
  return url;
};

exports.BlurImage = BlurImage;